export default __webpack_public_path__ + "static/media/featured-item-13.173425c5.png";